module.exports = __webpack_public_path__ + "static/media/video.82d9b86b.mp4";